// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostIntelligentPartnerCustomerPersonasManageRoleAddBody,
    BaseResponseIntelligentPartnerCustomerPersonaFoundResponse,
} from '../../../types';

/**
 * 新建客户画像
 *
 * @export
 * @tags 智能陪练-客户画像配置
 * @link [POST] /intelligentPartnerCustomerPersonas/manage/roleAdd
 */
export function postIntelligentPartnerCustomerPersonasManageRoleAdd(
    data: PostIntelligentPartnerCustomerPersonasManageRoleAddBody
): Promise<BaseResponseIntelligentPartnerCustomerPersonaFoundResponse>;
export function postIntelligentPartnerCustomerPersonasManageRoleAdd(
    data: PostIntelligentPartnerCustomerPersonasManageRoleAddBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerCustomerPersonaFoundResponse>;
export function postIntelligentPartnerCustomerPersonasManageRoleAdd(
    data: PostIntelligentPartnerCustomerPersonasManageRoleAddBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerCustomerPersonaFoundResponse> {
    return request<PostIntelligentPartnerCustomerPersonasManageRoleAddBody, never, never>(
        '/intelligentPartnerCustomerPersonas/manage/roleAdd',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerCustomerPersonasManageRoleAdd',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-客户画像配置'],
        path: '/intelligentPartnerCustomerPersonas/manage/roleAdd',
        method: 'post',
    },
];
